import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table, Button } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const ApprovedJobAdmin = () => {
    const [jobs, setJobs] = useState([]);

    // Fetch all jobs when the component loads
    useEffect(() => {
        const fetchJobs = async () => {
            try {
                const response = await axios.get("https://api.biznetusa.com/api/get-jobs");
                if (response.data && response.data.status === 200) {
                    setJobs(response.data.jobs);
                } else {
                    toast.error("Failed to fetch jobs. Please try again.");
                }
            } catch (error) {
                console.error("Error fetching jobs:", error);
                toast.error("An error occurred while fetching jobs.");
            }
        };
        fetchJobs();
    }, []);

    // Handle job approval
    const handleApprove = async (jobId, newStatus) => {
        try {
            const response = await axios.post("https://api.biznetusa.com/api/get-approve-job", {
                job_id: jobId,
                status: newStatus,
            });

            if (response.data && response.data.status === 200) {
                toast.success(`Job ${newStatus === 1 ? "approved" : "rejected"} successfully!`);
                setJobs((prevJobs) =>
                    prevJobs.map((job) =>
                        job.id === jobId ? { ...job, status: newStatus.toString() } : job
                    )
                );
            } else {
                toast.error("Failed to update job status.");
            }
        } catch (error) {
            console.error("Error updating job status:", error);
            toast.error("An error occurred while updating the job status.");
        }
    };

    // Handle job deletion
    const handleDelete = async (jobId) => {
        try {
            const response = await axios.delete(`https://api.biznetusa.com/api/deletejob/${jobId}`);
            if (response.data && response.data.status === 200) {
                toast.success("Job deleted successfully!");
                setJobs((prevJobs) => prevJobs.filter((job) => job.id !== jobId));
            } else {
                toast.error("Failed to delete job.");
            }
        } catch (error) {
            console.error("Error deleting job:", error);
            toast.error("An error occurred while deleting the job.");
        }
    };

    return (
        <div className="container mt-4">
            <ToastContainer />
            <h2 className="mb-4">Job List for Admin Approval</h2>
            {jobs.length > 0 ? (
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Title</th>
                            <th>Description</th>
                            <th>Job Type</th>
                            <th>Status</th>
                            <th>End Date</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {jobs.map((job) => (
                            <tr key={job.id}>
                                <td>{job.id}</td>
                                <td>{job.title}</td>
                                <td>{job.description}</td>
                                <td>{job.job_type || "N/A"}</td>
                                <td>{job.status === "1" ? "Approved" : "Pending"}</td>
                                <td>{job.end_date}</td>
                                <td>
                                    <Button variant="danger" size="sm" onClick={() => handleDelete(job.id)}>
                                        Delete
                                    </Button>{" "}
                                    {job.status === "0" && (
                                        <Button
                                            variant="success"
                                            size="sm"
                                            onClick={() => handleApprove(job.id, 1)}
                                        >
                                            Approve
                                        </Button>
                                    )}
                                    {job.status === "1" && (
                                        <Button
                                            variant="warning"
                                            size="sm"
                                            onClick={() => handleApprove(job.id, 0)}
                                        >
                                            Reject
                                        </Button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            ) : (
                <p>No jobs available at the moment.</p>
            )}
        </div>
    );
};

export default ApprovedJobAdmin;
